import * as React from 'react';
import { IRiskPotReportNote } from '../../../models/IRiskPotReport';
import { RiskPotReportNotesTable } from './RiskPotReportNotesTable';
import { RiskPotReportNotesModal } from './RiskPotReportNotesModal';

interface IRiskPotReportNotes {
    riskPotReportNotes: IRiskPotReportNote[];
    riskPotReportId: number;
    changeSuccessMessage: (message: string) => void;
    getRiskPotReport: () => void;
    canAccessNotes: boolean;
}

export const RiskPotReportNotes: React.FunctionComponent<IRiskPotReportNotes> = ({ riskPotReportId, riskPotReportNotes, getRiskPotReport, changeSuccessMessage, canAccessNotes }) => {

    const [selectedNote, setSelectedNote] = React.useState<IRiskPotReportNote>();
    const [renderNoteModal, setRenderNoteModal] = React.useState<boolean>(false);

    return (
        <>
            {
                canAccessNotes ?
                    <>
                        <RiskPotReportNotesTable setSelectedNote={setSelectedNote} riskPotReportNotes={riskPotReportNotes} openNoteModalClicked={() => setRenderNoteModal(true)} getRiskPotReport={getRiskPotReport} changeSuccessMessage={changeSuccessMessage} riskPotReportId={riskPotReportId} />
                        <RiskPotReportNotesModal setSelectedNote={setSelectedNote} riskPotReportId={riskPotReportId} riskPotReportNote={selectedNote} getRiskPotReport={getRiskPotReport} changeSuccessMessage={changeSuccessMessage} renderForm={renderNoteModal} onClose={() => setRenderNoteModal(false)} />
                        <hr />
                    </>
                    : null
            }
        </>
    )
}